import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const logo = process.env.PUBLIC_URL + '/shoval-logo.png';

export const handleScroll = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const lastScrollY = useRef(0);
  const location = useLocation();
  const navigate = useNavigate();
  const isCoursePage = location.pathname === '/course';

  useEffect(() => {
    const onScroll = () => {
      const currentY = window.scrollY;
      setScrolled(currentY > 20);
      if (currentY > lastScrollY.current && currentY > 80) {
        setHidden(true);
      } else {
        setHidden(false);
      }
      lastScrollY.current = currentY;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goToSection = (id) => {
    setIsOpen(false);
    if (isCoursePage) {
      navigate('/');
      setTimeout(() => handleScroll(id), 300);
    } else {
      handleScroll(id);
    }
  };

  const navLinks = [
    { label: 'בית', id: 'hero' },
    { label: 'פרופיל', id: 'profile' },
    { label: 'חבילות', id: 'packages' },
    { label: 'המלצות', id: 'advices' },
    { label: 'צור קשר', id: 'contact' },
  ];

  return (
    <header
      dir="ltr"
      className={`fixed top-0 left-0 right-0 z-50 flex justify-between items-center px-6 py-3 transition-all duration-300 ${
        scrolled || isCoursePage ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      } ${hidden ? '-translate-y-full' : 'translate-y-0'}`}
    >
      <button onClick={() => navigate('/')} className="h-16 focus:outline-none">
        <img src={logo} alt="Shoval Saada" className="h-full object-contain" />
      </button>

      <nav className="hidden md:flex flex-row-reverse items-center gap-1 text-sm font-medium">
        {navLinks.map((link) => (
          <button
            key={link.id}
            onClick={() => goToSection(link.id)}
            className={`px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors ${
              scrolled || isCoursePage ? 'text-gray-800' : 'text-white'
            }`}
          >
            {link.label}
          </button>
        ))}
        <button
          onClick={() => { window.scrollTo(0, 0); navigate('/course'); }}
          className="mr-2 px-4 py-2 bg-gradient-to-r from-purple-600 to-pink-500 text-white rounded-full text-sm font-semibold hover:opacity-90 transition-opacity shadow-md"
        >
          קורס
        </button>
      </nav>

      <div className="md:hidden">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`p-2 focus:outline-none ${scrolled || isCoursePage ? 'text-gray-800' : 'text-white'}`}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d={isOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16m-7 6h7'}
            />
          </svg>
        </button>
      </div>

      {isOpen && (
        <nav className="absolute top-full right-0 w-full bg-white shadow-lg flex flex-col items-center gap-2 py-4 text-sm font-medium md:hidden z-50">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => goToSection(link.id)}
              className="px-4 py-2 hover:text-purple-600 text-gray-700 w-full text-center"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => { window.scrollTo(0, 0); navigate('/course'); setIsOpen(false); }}
            className="mt-2 px-6 py-2.5 bg-gradient-to-r from-purple-600 to-pink-500 text-white rounded-full font-semibold"
          >
            קורס
          </button>
        </nav>
      )}
    </header>
  );
};

export default Navbar;
